import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProgrammesPage from "./pages/ProgrammesPage";
import LearningPage from "./pages/LearningPage";
import ThinkingToolboxPage from "./pages/ThinkingToolboxPage";
import FrameworkPage from "./pages/FrameworkPage";
import OrganisationsPage from "./pages/OrganisationsPage";
import KnowledgePage from "./pages/KnowledgePage";
import InsightArticlePage from "./pages/InsightArticlePage";
import AssessmentPage from "./pages/AssessmentPage";
import FounderPage from "./pages/FounderPage";
import AdvisoryPage from "./pages/AdvisoryPage";
import EventsPage from "./pages/EventsPage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-navy focus:px-4 focus:py-2 focus:font-sub focus:text-sm focus:text-white"
        data-testid="skip-to-content"
      >
        Skip to main content
      </a>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main id="main-content" className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programmes" element={<ProgrammesPage />} />
            <Route path="/learning" element={<LearningPage />} />
            <Route path="/learning-paths" element={<Navigate to="/learning" replace />} />
            <Route path="/thinking" element={<Navigate to="/thinking-toolbox" replace />} />
            <Route path="/thinking-toolbox" element={<ThinkingToolboxPage />} />
            <Route path="/thinking-toolbox/:slug" element={<FrameworkPage />} />
            <Route path="/organisations" element={<OrganisationsPage />} />
            <Route path="/knowledge" element={<KnowledgePage />} />
            <Route path="/knowledge/insights/:slug" element={<InsightArticlePage />} />
            <Route path="/assessment" element={<AssessmentPage />} />
            <Route path="/founder/rakesh-gopinathan" element={<FounderPage />} />
            <Route path="/advisory" element={<AdvisoryPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/legal/:doc" element={<LegalPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
